import moment from "moment";


const params = {
    startDate: moment(new Date()).add(-1,'days').format('YYYY-MM-DD 12:00:00'),
    endDate: moment(new Date()).format('YYYY-MM-DD 12:00:00'),
    centerFilter: '成都分拨中心',
    province:'',
    notNextpProv: []
    // centerFilter: { name: "成都分拨中心", code: "5712000" },
    // province: { name: "西南经营本部", code: "0212000" },

    // startDate: '',
    // endDate: '',
    // province: '',
    // centerFilter: '',
}

export default {
    namespace: 'provincecapacity',

    state: {
        searchParams: { ...params },
        seachStatus: false,
    },

    reducers: {
        updateState(state, { payload }) {
            return { ...state, ...payload };
        },
        updateSearchParams(state, { payload }) {
            return { ...state, searchParams: { ...state.searchParams, ...payload } };
        },
        resetSearchParam(state) {
            return { ...state, searchParams: { ...params } };
        },
    }
}
